import {BleDevice} from '@hybird/device/protocol/ble'
import {WebError} from '@hybird/core/error'
import {deviceError} from '@hybird/device/deviceError'
import {DeviceEvent} from '@hybird/core/device/protocol'
import {isSupport, xda} from "@hybird/flutter/bridge";
import {Buffer} from "buffer";

class FlutterSerialDevice extends BleDevice {
  /**
   * @type{SerialPort}
   */
  port

  /**
   * @type{BleV2Device}
   */
  codec

  /**
   * @type{Config}
   */
  config

  constructor(config) {
    super(config.serial.name, {})
    this.config = config
  }

  async _connect({clear, resolve, reject}) {
    try {
      const usbDevices = await xda.usbDevices();
      this.port = await this.config.serial.requestPort(usbDevices.filter(map => {
        return (this.config.serial.usbVendorId && map.vid === this.config.serial.usbVendorId)
                && (this.config.serial.usbProductId && map.pid === this.config.serial.usbProductId)
      }));

      const result = await xda.connectUsbDevice({
        address: this.port,
        ...this.config.serial
      })

      if (!result) {
        reject(WebError.code(deviceError.CONNECT_ERROR))
      }

      await this.listenSerial()

      await xda.onUsbDeviceStateChange((event) => {
        if (event.address === this.port) {
          console.log('Serial onUsbDeviceStateChange: ', JSON.stringify(event))
          if (event.event !== "ACTION_USB_ATTACHED") {
            this.emit(DeviceEvent.DISCONNECTED);
            this._connected = false;
          }
        }
      })

      this._connected = true;

      resolve();
    } catch (e) {
      reject(WebError.error(e, deviceError.CONNECT_ERROR))
    }
  }

  async listenSerial() {
    const chunks = []

    const postMessage = async (chunk) => {
      chunks.push(chunk)
      const content = chunks.join('')
      console.log('serial all readable', content, content.length)
      await this._onMessage(content)
      chunks.splice(0, chunks.length)
    }

    const subMessage = async (chunk) => {
      // 新增缓冲区完整检查
      const combined = chunks.concat(chunk).join('')
      if (combined.includes('|#')) {
        chunks.splice(0, chunks.length)
        chunk = combined // 将合并后的完整数据作为新chunk处理
      }
      if (chunk.indexOf('|#') + 2 === chunk.length && chunk.endsWith('|#')) {
        await postMessage(chunk)
      } else if (chunk.includes('|#')) {
        const i = chunk.indexOf('|#')

        if (i > -1) {
          const s1 = chunk.substring(0, i + 2)
          const s2 = chunk.substring(i + 2, chunk.length)

          await postMessage(s1)
          await subMessage(s2)
        }
      } else {
        chunks.push(chunk)
      }
    }


    this.onUsbDeviceValueChange = await xda.onUsbDeviceValueChange(this.port, async (data) => {
      if (data.address === this.port) {
        await subMessage(Buffer.from(data.value, "hex").toString());
      }
    });

    await xda.notifyUsbDeviceValueChange(this.port);
  }

  async serialMessage(subMessage, data) {
    if (data.address === this.port) {
      await subMessage(Buffer.from(data.value, "hex").toString());
    }
  }

  async _write({clear, buffer, resolve, reject}) {
    try {
      await xda.writeUsbDeviceValue(this.port, buffer.toString("hex"));
      resolve()
    } catch (e) {
      reject(WebError.error(deviceError.WRITE_ERROR, e))
    }
  }

  async _onMessage(result) {
    const parseResult = this.codec.decode(result)
    await this.emitMessage(parseResult)
  }

  get state() {
    return this.connected ? 'connected' : 'disconnected'
  }

  get connected() {
    return this._connected;
  }

  async _disconnect() {
    // if (this.port) {
    //   await xda.disconnectUsbDevice(this.port);
    // }

    if (this.onUsbDeviceValueChange) {
      this.onUsbDeviceValueChange.cancel();
      this.onUsbDeviceValueChange = null;
    }

    this._connected = false;
    this.port = null;
  }
}

const createFlutterSerialDevice = {
  create: (config) => {
    return new FlutterSerialDevice(config)
  },
  isSupport() {
    return isSupport()
  },
  canConnect: (config, device) => {
    return config.serial.name === device.name;
  }
}

export {FlutterSerialDevice, createFlutterSerialDevice}
